export default __webpack_public_path__ + "static/media/image2.44d66ba1.jpg";